export default "/images/kurv-logo.png?5c2515c1387fe654f94b8f812df52289";